import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgCheckmarkCircleFilled60 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM43.0614 22.0148C43.8451 21.0349 43.6636 19.6228 42.6559 18.8607C41.6482 18.0986 40.1959 18.2751 39.4121 19.2549L26.1495 35.8354L20.5028 29.5605C19.6622 28.6263 18.2018 28.5317 17.241 29.3491C16.2803 30.1665 16.1829 31.5865 17.0236 32.5207L24.5147 40.8453C24.9691 41.3502 25.6315 41.6313 26.3212 41.612C27.0108 41.5926 27.6554 41.2747 28.079 40.7452L43.0614 22.0148Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkCircleFilled60);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=CheckmarkCircleFilled60.svg.js.map
